import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withSettings } from '../../withSettings'

@withSettings
export default class StaticMap extends Component {

  static propTypes = {
    style: PropTypes.string.isRequired
  }

  static defaultProps = {
    style: 'mapbox/streets-v12',
  }

  render() {
    const { style } = this.props
    const filters = this.props.getSettingsAt('search.default_filters', {
      map_zoom: 8,
      map_center: {
        lat: 34.4417358208926,
        lng: -118.059786516377
      }
    })

    return (
      <img className="static-map" src={`https://api.mapbox.com/styles/v1/${style}/static/${filters.map_center.lng},${filters.map_center.lat},${filters.map_zoom}/250x200?access_token=${process.env.MAPBOX_ACCESS_TOKEN}`} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/MapSelector/StaticMap.js